<template>
    <div class="city-dropdown" v-if="!$apollo.loading">
        <label for="inputState" class="sr-only">City</label>
        <b-dropdown :text="text" variant="default">
            <b-dropdown-item-button @click.prevent="selectedOption(null)">All Cities</b-dropdown-item-button>
            <b-dropdown-item-button @click.prevent="selectedOption('remote')" v-if="showRemoteWorkOpt">Remote Work</b-dropdown-item-button>
            <b-dropdown-item-button @click.prevent="selectedOption(city)" v-for="city in cities" :key="city.id">
                {{ city.name }}
            </b-dropdown-item-button>
        </b-dropdown>
    </div>
</template>

<script>
import listCities from '@/gql/ListCities.gql';

export default {
    name: 'filter-by-city',

    props: {
        showRemoteWorkOpt: {
            type: Boolean,
            default: false
        },
    },

    apollo: {
        cities: listCities,
    },

    data() {
        return {
            text: 'All Cities',
        }
    },

    methods: {
        selectedOption(city = {}) {
            this.text = (city) ? city.name : 'All Cities';
            if (city === 'remote') {
                this.text = 'Remote work'
                this.$emit('input', 'null');
            } else {
                this.$emit('input', city);
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    .city-dropdown {
        display: inline;
    }

    .city-dropdown /deep/ .dropdown-toggle {
        padding: 0;
        color: $primary;
        font-size: 24px;
        
        @include media-breakpoint-up(md) {
            font-size: 28px;
        }

        &:active,
        &:hover,
        &:focus {
            box-shadow: none;
        }

        &:after {
            margin-left: 14px;
            border: solid $primary;
            border-width: 0 3px 3px 0;
            display: inline-block;
            padding: 3px;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
        }
    }

    .city-dropdown /deep/ .dropdown-menu {
        max-height: 250px;
        overflow-y: scroll;
    }
    .city-dropdown .btn-group, .btn-group-vertical {
        vertical-align: baseline;
    }
</style>
